module.exports = __webpack_public_path__ + "img/9_94.1b8845a7.png";